import * as React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { mergeClasses } from '../constants';
import { TooltipPlacement } from '../types';

export const TOOLTIP_DELAY_INSTANT_SHOW_INSTANT_HIDE = { show: 0, hide: 0 };
export const TOOLTIP_DELAY_INSTANT_SHOW_WAIT_HIDE = { show: 0, hide: 700 };
export const TOOLTIP_DELAY_WAIT_SHOW_INSTANT_HIDE = { show: 1000, hide: 0 };

type Props = {
  block?: boolean;
  children: React.ReactNode;
  size?: 'lg' | 'xl';
  className?: string;
  delay?: { show: number; hide: number };
  placement?: TooltipPlacement;
  tooltip: React.ReactNode;
  allowHover?: boolean;
  flip?: boolean;
};

let idCounter = 0;

export default class LightTooltip extends React.Component<Props> {
  id: string;
  constructor(props: Props) {
    super(props);
    this.id = `ltt_${++idCounter}`;
  }

  render() {
    const {
      block,
      children,
      className,
      delay,
      placement = 'bottom',
      size,
      tooltip,
      allowHover,
      ...rest
    } = this.props;
    const showHideDelay = delay ? delay : { show: 700, hide: 700 };
    return (
      <span id={this.id} className={block ? 'd-inline-block' : undefined}>
        {children}
        <UncontrolledTooltip
          trigger="hover focus"
          className={mergeClasses(['light-tooltip', size, className])}
          delay={showHideDelay}
          placement={placement}
          modifiers={{
            flip: {
              enabled: false,
            },
            preventOverflow: {
              enabled: false,
            },
          }}
          {...rest}
          target={this.id}
          fade={false}
          autohide={!allowHover}
        >
          {tooltip}
        </UncontrolledTooltip>
      </span>
    );
  }
}

type ConditionalTooltipProps = {
  tooltip: string;
  visible: boolean;
};

/**
 * An extension to LightTooltip whose existence can be controlled via a prop.
 */
export const ConditionalTooltip: React.FunctionComponent<
  ConditionalTooltipProps
> = ({ tooltip, visible, children }) => {
  if (!visible) {
    return <>{children}</>;
  }

  return (
    <LightTooltip tooltip={tooltip} placement="top">
      {children}
    </LightTooltip>
  );
};
